export const brand = 'bcom';
export const headers = {
  'x-requested-with': 'XMLHttpRequest',
};
export const GENERIC_ERROR_MESSAGE = 'Something went wrong, please try again later';
export const DEFAULT_ERROR_MESSAGE =
  "We're experiencing a technical glitch. Please try again later or call us at 1-800-777-0000 for immediate assistance.";
export const CREATE_LIST_MODAL = {
  TOGGLE_TEXT: 'Make this list public',
  LEARN_MORE: {
    SHARE_LIST_MSG:
      'Public lists can be shared with friends and family. Your other lists will remain private, unless you opt to make them public too. No lists are accessible outside of bloomingdales.com.',
  },
};
export const ALERTS_TOOLTIP_TEXT = 'Get email alerts when an item on your list goes on sale or is about to sell out.';
export const CS_PHONE_NUMERIC = '1-800-777-0000';
export const YOU_SAVED = 'Estimated savings';
export const ATB_PROS_ZONES = ['ATBPage_Overlay'];
export const REGISTRY_FOR = 'For';
export const WISHLIST_TITLE_CLASS = 'h2';
export const CREATE_ACCOUNT_BUTTON = 'CREATE AN ACCOUNT';
export const MOVE_ITEM_SLIDEOUT = {
  TITLE: 'Move item',
  SUCCESS_TITLE: 'SUCCESS!',
};
export const PRODUCT_IMAGE_URL = (imagePath) => `https://images.bloomingdalesassets.com/is/image/BLM/products/${imagePath}`;
export const MERCHANT_NAME = 'bloomingdales';
